import {QueryCacheKeys} from '../../api/cache';
import {getInvoice} from '../../api/invoices';
import PDFPage from '../PDFPage';
import InvoiceFooterPreview from './InvoiceFooterPreview';
import InvoiceHeaderPreview from './InvoiceHeaderPreview';
import InvoiceLineItemPreview from './InvoiceLineItemPreview';
import InvoiceLineItemsHeaderPreview from './InvoiceLineItemsHeaderPreview';
import {Box} from '@sproutsocial/racine';
import {useQuery} from '@tanstack/react-query';

interface InvoicePreviewProps {
	invoiceId: string;
}

const InvoicePreview = ({invoiceId}: InvoicePreviewProps) => {
	const {data: invoice} = useQuery({
		queryKey: QueryCacheKeys.invoice(invoiceId),
		queryFn: () => getInvoice(invoiceId),
	});

	if (!invoice) {
		return null;
	}

	return (
		<Box bg='white'>
			<PDFPage>
				<InvoiceHeaderPreview invoiceId={invoiceId} />

				<Box my='space.500'>
					<InvoiceLineItemsHeaderPreview />
					{invoice.items.map((item) => (
						<InvoiceLineItemPreview key={item.id} lineItem={item} />
					))}
				</Box>

				<InvoiceFooterPreview invoiceId={invoiceId} />
			</PDFPage>
		</Box>
	);
};

export default InvoicePreview;
